import { reduceObject } from '../../helpers/reduce-object';

export const prepareData = <T extends Record<string, U>, U>(
    applyTemplate: (template: string) => string,
    data: T
) =>
    reduceObject<U, U | string>(data, (eventData, [key, template]) => ({
        ...eventData,
        [key]: typeof template === 'string' ? applyTemplate(template) : template,
    }));
